import FormCreateUser from "../users/FormCreateUser";
import Modal from "./Modal";

export default function ModalCreateUser({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={"Crear usuario"}
      content={<FormCreateUser onClose={onClose} />}
    />
  );
}
